(() => {
 if(window.TripleCSocialInteractions)return;
 document.addEventListener('click',async event=>{
  const button=event.target.closest?.('[data-comment-reply],[data-reply-cancel],[data-post-share]');if(!button)return;
  const post=button.closest('.tc-post');if(!post)return;
  if(button.hasAttribute('data-post-share')){
   const url=new URL(button.dataset.postShare,location.origin);const status=post.querySelector('[data-social-status]');
   try{if(navigator.share)await navigator.share({title:'Triple C collector post',url:url.href});else{await navigator.clipboard.writeText(url.href);if(status)status.textContent='Post link copied.';}}
   catch(error){if(error.name!=='AbortError'&&status)status.textContent='Copy this post link: '+url.href;}return;
  }
  const form=post.querySelector('.tc-comment-form');if(!form)return;
  const parent=form.querySelector('[name="parentId"]'),note=form.querySelector('[data-reply-context]'),cancel=form.querySelector('[data-reply-cancel]');
  if(button.hasAttribute('data-reply-cancel')){parent.value='';note.textContent='';cancel.hidden=true;}
  else{parent.value=button.dataset.commentReply;note.textContent='Replying to '+button.dataset.replyName;cancel.hidden=false;form.querySelector('[name="comment"]').focus();form.scrollIntoView({block:'nearest'});}
 });
 window.TripleCSocialInteractions=true;
})();
